module.exports = __webpack_public_path__ + "img/icon-activity-pink.7b777146.png";